/*
 * @Desc: 文件描述
 * @Author: jiayi zhu
 * @Date: 2020-07-06 11:47:34
 * @LastEditors: jiayi zhu
 */
export default {
  getQyWechatCode(data) {
    return this.http('Longan', 'get', 'api/v1/wework/agents/jsapi_config', data);
  },
  getUserMes(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/customer_detail', data);
  },
  getUserOrderMes(data) {
    return this.http('Longan', 'get', '/api/v1/users/one_order_list', data);
  },
  getUserMemberMes(data) {
    return this.http('Longan', 'get', '/api/v1/users/member_info', data);
  },
  getUserInfo(data) {
    return this.http('Longan', 'get', '/api/v1/wework/agents/userinfo', data);
  },
  addUserKey(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/bind_user_key', data);
  },
  clearUserKey(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/clear_user_key', data);
  },
  getCouponList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/ice_coupons', data);
  },
  getWechatGoodList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/sale_goods', data);
  },
  getUserTags(data) {
    return this.http('Longan', 'get', '/api/v1/wework/ice_tags', data);
  },
  goAddUserTags(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/add_tags', data);
  },
  deleteUserTag(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/remove_tags', data);
  },
  postCoupon(data) {
    return this.http('Longan', 'post', '/api/v1/wework/ice_coupons/send_coupon', data);
  },
  getIceBots(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/ice_bots', data);
  },
  updateWechatUserMes(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/update_profile', data);
  },
  getCustomList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/brief_index', data);
  },
  getFollowList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/follow_ups', data);
  },
  postFollowMes(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/create_follow_up', data);
  },
  postWechatAuthCode(data) {
    return this.http('Longan', 'post', '/api/v1/questionnaires/auth_code', data);
  },
  postWechatAuth(data) {
    return this.http('Bee', 'post', '/go_api/v2/questionnaires/auth', data);
  },
  postQuestionnaire(data) {
    return this.http('Longan', 'post', '/api/v1/questionnaires/commit', data);
  },
  getBehaviorList(data) {
    return this.http('DataInterface', 'get', 'v1/external-customers/get-customer-by-behavior', data);
  },
  getBehavior(data) {
    return this.http('DataInterface', 'get', 'v1/external-customers/get-behavior-list', data);
  },
  getMomentList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/moments', data);
  },
  getMomentMedia(data) {
    return this.http('Longan', 'post', '/api/v1/wework/moments/get_media', data);
  },
  getMomentCreatorMes(data) {
    return this.http('Longan', 'get', '/api/v1/wework/moments/creator_info', data);
  },
  getWaitFollowList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/wait_follow_list', data);
  },
  getWechatCart(data) {
    return this.http('Longan', 'get', '/api/v1/users/one_cart_items', data);
  },
  changeFollowState(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/complete_follow_up', data);
  },
  getVisitList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/revisits', data);
  },
  createVisitRecord(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/create_revisit', data);
  },
  getWechatHealthSurvey(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/health_profile', data);
  },
  saveWechatHealthSurvey(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/update_health_profile', data);
  },
  getWechatHealthSurveySummary(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/health_summary', data);
  },
  getWechatOrder(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/all_orders', data);
  },
  addEkaOrder(data) {
    return this.http('DataInterface', 'post', 'v1/external-customers/bind-order', data);
  },
  getCustomListNew(data) {
    return this.http('DataInterface', 'get', 'v1/external-customers/get-uk-and-order-no-info', data);
  },
  sendGroupMessage(data) {
    return this.http('DataInterface', 'post', 'v1/external-customers/send-group-message', data);
  }
};
